import script from "./SideRightOrganism.vue?vue&type=script&setup=true&lang=js"
export * from "./SideRightOrganism.vue?vue&type=script&setup=true&lang=js"

import "./SideRightOrganism.vue?vue&type=style&index=0&id=a6d66f12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6d66f12"]])

export default __exports__